import appColors from '../../common/app_colors';

export const cardTitleStyle = () => {
  const style = {
    mb: '5px',
    textAlign: 'left',
  };
  return style;
};

export const cardBodyStyle = () => {
  const style = {
    fontWeight: 500,
    fontSize: '12.6px',
    width: '180px',
    textAlign: 'left',
  };
  return style;
};

export const cardContainerStyle = (isSelected) => {
  const style = {
    background: appColors.buttons.tetriaryBackground,
    p: '25px',
    border: isSelected ? `4px solid ${appColors.buttons.selectedButtonOutline}` : 'none',
  };
  return style;
};
